import axios from 'axios';
import { useQuery } from 'react-query';
import { Tags } from '../api/responses';

export const useGetAllTags = (type?: string, lang?: number | null) => {
    const getTags = async (): Promise<Tags> => {
        const params: any = {};

        if (lang) params['language'] = lang;
        if (type) params['game_type'] = type;

        const tagsData = await axios
            .get(`${process.env.REACT_APP_API_URL}/tags/`, { params })
            .then((res) => res.data);
        return tagsData;
    };

    const { data, isLoading, isError, error } = useQuery({
        queryKey: ['get-tags', { type, lang }],
        queryFn: getTags,
        staleTime: Infinity,
    });

    return { data, isError, isLoading, error };
};
